// // components/RecruitmentSummaryChart.js
// import React, { useRef, useEffect, useState } from "react";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Filler,
//   Tooltip,
//   Legend,
// } from "chart.js";

// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

// const labels = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

// const RecruitmentSummaryChart = () => {
//   const chartRef = useRef(null);

//   const createGradients = (ctx, chartArea) => {
//     // Create gradient for "Present" line (#0077FE to #FFFFFF)
//     const presentGradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
//     presentGradient.addColorStop(0, '#0077FE');
//     presentGradient.addColorStop(1, '#FFFFFF');

//     // Create gradient for "Absent" line (#0D9C6C80 to #FFFFFF)
//     const absentGradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
//     absentGradient.addColorStop(0, '#0D9C6C80');
//     absentGradient.addColorStop(1, '#FFFFFF');

//     return { presentGradient, absentGradient };
//   };

//   const data = {
//     labels,
//     datasets: [
//       {
//         label: "Present",
//         data: [5, 90, 85, 20, 30, 60, 70, 60, 50, 40, 30, 50],
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;
          
//           if (!chartArea) {
//             return 'rgba(0, 119, 254, 0.2)';
//           }
          
//           const { presentGradient } = createGradients(ctx, chartArea);
//           return presentGradient;
//         },
//         borderColor: "#0077FE",
//         fill: true,
//         tension: 0.4,
//         pointRadius: 0,
//       },
//       {
//         label: "Absent",
//         data: [5, 10, 20, 35, 40, 38, 35, 40, 45, 43, 40, 38],
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;
          
//           if (!chartArea) {
//             return 'rgba(13, 156, 108, 0.2)';
//           }
          
//           const { absentGradient } = createGradients(ctx, chartArea);
//           return absentGradient;
//         },
//         borderColor: "#0D9C6C",
//         fill: true,
//         tension: 0.4,
//         pointRadius: 0,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         callbacks: {
//           label: (context) => `${context.dataset.label}: ${context.parsed.y}`,
//         },
//       },
//     },
//     scales: {
//       x: {
//         grid: {
//           display: false,
//         },
//         ticks: {
//           color: "#6B7280",
//         },
//       },
//       y: {
//         beginAtZero: true,
//         grid: {
//           color: "#E5E7EB",
//           borderDash: [4, 4],
//         },
//         ticks: {
//           stepSize: 25,
//           color: "#6B7280",
//         },
//       },
//     },
//   };

//   return (
//     <div className="h-[203px]">
//       <Line ref={chartRef} data={data} options={options} />
//     </div>
//   );
// };

// export default RecruitmentSummaryChart;


// components/RecruitmentSummaryChart.js
// import React, { useRef, useEffect, useState } from "react";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Filler,
//   Tooltip,
//   Legend,
// } from "chart.js";

// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

// const labels = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

// const RecruitmentSummaryChart = ({ selectedYear }) => {

//   // console.log("Selected Year: ", selectedYear);
//   const chartRef = useRef(null);

//   const getDataByYear = (year) => {
//     switch (year) {
//       case "2023":
//         return {
//           present: [10, 20, 30, 40, 50, 60, 70, 80, 90, 85, 75, 60],
//           absent: [5, 10, 12, 14, 16, 20, 18, 17, 19, 21, 22, 23],
//         };
//       case "2024":
//         return {
//           present: [5, 90, 85, 20, 30, 60, 70, 60, 50, 40, 30, 50],
//           absent: [5, 10, 20, 35, 40, 38, 35, 40, 45, 43, 40, 38],
//         };
//       case "2025":
//         return {
//           present: [50, 60, 55, 70, 65, 75, 80, 90, 85, 88, 90, 95],
//           absent: [10, 15, 12, 14, 10, 8, 6, 7, 5, 6, 4, 3],
//         };
//       default:
//         return { present: [], absent: [] };
//     }
//   };

//   const yearData = getDataByYear(selectedYear);

//   const createGradients = (ctx, chartArea) => {
//     // Create gradient for "Present" line (lighter blue with more transparency)
//     const presentGradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
//     presentGradient.addColorStop(0, 'rgba(0, 119, 254, 0.3)');
//     presentGradient.addColorStop(1, 'rgba(255, 255, 255, 0.1)');

//     // Create gradient for "Absent" line (lighter green with more transparency)
//     const absentGradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
//     absentGradient.addColorStop(0, 'rgba(13, 156, 108, 0.3)');
//     absentGradient.addColorStop(1, 'rgba(255, 255, 255, 0.1)');

//     return { presentGradient, absentGradient };
//   };

//   const data = {
//     labels,
//     datasets: [
//       {
//         label: "Absent",
//         data: yearData.absent,
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;
          
//           if (!chartArea) {
//             return 'rgba(13, 156, 108, 0.2)';
//           }
          
//           const { absentGradient } = createGradients(ctx, chartArea);
//           return absentGradient;
//         },
//         borderColor: "#0D9C6C",
//         borderWidth: 1.5,
//         fill: 'origin',
//         tension: 0.4,
//         pointRadius: 0,
//       },
//       {
//         label: "Present",
//         data: yearData.present,
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;
          
//           if (!chartArea) {
//             return 'rgba(0, 119, 254, 0.2)';
//           }
          
//           const { presentGradient } = createGradients(ctx, chartArea);
//           return presentGradient;
//         },
//         borderColor: "#0077FE",
//         borderWidth: 1.5,
//         fill: '-1',
//         tension: 0.4,
//         pointRadius: 0,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         callbacks: {
//           label: (context) => `${context.dataset.label}: ${context.parsed.y}`,
//         },
//       },
//     },
//     scales: {
//       x: {
//         grid: {
//           display: false,
//         },
//         ticks: {
//           color: "#6B7280",
//         },
//       },
//       y: {
//         beginAtZero: true,
//         grid: {
//           color: "#E5E7EB",
//           borderDash: [4, 4],
//         },
//         ticks: {
//           stepSize: 25,
//           color: "#6B7280",
//         },
//       },
//     },
//   };

//   return (
//     <div className="h-[199px]">
//       <Line ref={chartRef} data={data} options={options} />
//     </div>
//   );
// };

// export default RecruitmentSummaryChart;


// import React, { useRef, useEffect, useState } from "react";
// import { Line } from "react-chartjs-2";
// import axios from "axios";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Filler,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { getToken } from "../../utils/tokenUtils";

// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

// const labels = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

// const RecruitmentSummaryChart = ({ selectedYear }) => {
//   const chartRef = useRef(null);
//   const token = getToken()

//   const [jobsOpened, setJobsOpened] = useState([]);
//   const [applicationsReceived, setApplicationsReceived] = useState([]);
//   const [shortlisted, setShortlisted] = useState([]);
//   const [interviewed, setInterviewed] = useState([]);
//   const [onboarded, setOnboarded] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // const token = localStorage.getItem("access_token");

//         const res = await axios.get(
//           `https://hrmsnew.prepstripe.com/api/dashboard/recruitment-summary?year=${selectedYear}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         const summary = res.data?.data?.summary || [];

//         setJobsOpened(summary.map((item) => item.jobs_opened));
//         setApplicationsReceived(summary.map((item) => item.applications_received));
//         setShortlisted(summary.map((item) => item.shortlisted))
//         setInterviewed(summary.map((item) => item.interviewed))
//         setOnboarded(summary.map((item) => item.onboarded))

//       } catch (error) {
//         console.error("Failed to fetch recruitment data:", error);
//       }
//     };

//     fetchData();
//   }, [selectedYear]);

//   const createGradients = (ctx, chartArea) => {
//     const presentGradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
//     presentGradient.addColorStop(0, "rgba(0, 119, 254, 0.3)");
//     presentGradient.addColorStop(1, "rgba(255, 255, 255, 0.1)");

//     const absentGradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
//     absentGradient.addColorStop(0, "rgba(13, 156, 108, 0.3)");
//     absentGradient.addColorStop(1, "rgba(255, 255, 255, 0.1)");

//     return { presentGradient, absentGradient };
//   };

//   const data = {
//     labels,
//     datasets: [
//       // one
//       {
//         label: "Applications Received",
//         data: applicationsReceived,
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) return "rgba(13, 156, 108, 0.2)";
//           const { absentGradient } = createGradients(ctx, chartArea);
//           return absentGradient;
//         },
//         borderColor: "#0D9C6C",
//         borderWidth: 1.5,
//         fill: "origin",
//         tension: 0.4,
//         pointRadius: 0,
//       },
//       // two
//       {
//         label: "Jobs Opened",
//         data: jobsOpened,
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) return "rgba(0, 119, 254, 0.2)";
//           const { presentGradient } = createGradients(ctx, chartArea);
//           return presentGradient;
//         },
//         borderColor: "#0077FE",
//         borderWidth: 1.5,
//         fill: "-1",
//         tension: 0.4,
//         pointRadius: 0,
//       },
//       // three
//       {
//         label: "Shortlisted",
//         data: shortlisted,
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) return "rgba(0, 119, 254, 0.2)";
//           const { presentGradient } = createGradients(ctx, chartArea);
//           return presentGradient;
//         },
//         borderColor: "#0C9D6D",
//         borderWidth: 1.5,
//         fill: "-1",
//         tension: 0.4,
//         pointRadius: 0,
//       },
//       // four
//       {
//         label: "Interviewed",
//         data: interviewed,
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) return "rgba(0, 119, 254, 0.2)";
//           const { presentGradient } = createGradients(ctx, chartArea);
//           return presentGradient;
//         },
//         borderColor: "#0E9F6F",
//         borderWidth: 1.5,
//         fill: "-1",
//         tension: 0.4,
//         pointRadius: 0,
//       },
//       // five
//       {
//         label: "Onboarded",
//         data: onboarded,
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) return "rgba(0, 119, 254, 0.2)";
//           const { presentGradient } = createGradients(ctx, chartArea);
//           return presentGradient;
//         },
//         borderColor: "#0A9D6B",
//         borderWidth: 1.5,
//         fill: "-1",
//         tension: 0.4,
//         pointRadius: 0,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: { display: false },
//       tooltip: {
//         callbacks: {
//           label: (context) => `${context.dataset.label}: ${context.parsed.y}`,
//         },
//       },
//     },
//     scales: {
//       x: {
//         grid: { display: false },
//         ticks: { color: "#6B7280" },
//       },
//       y: {
//         beginAtZero: true,
//         grid: { color: "#E5E7EB", borderDash: [4, 4] },
//         ticks: { stepSize: 25, color: "#6B7280" },
//       },
//     },
//   };

//   return (
//     <div className="h-[199px]">
//       <Line ref={chartRef} data={data} options={options} />
//     </div>
//   );
// };

// export default RecruitmentSummaryChart;


// import React, { useRef, useEffect, useState } from "react";
// import { Line } from "react-chartjs-2";
// import axios from "axios";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Filler,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { getToken } from "../../utils/tokenUtils";

// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

// const labels = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

// const RecruitmentSummaryChart = ({ selectedYear }) => {
//   const chartRef = useRef(null);
//   const token = getToken()

//   const [jobsOpened, setJobsOpened] = useState([]);
//   const [applicationsReceived, setApplicationsReceived] = useState([]);
//   const [shortlisted, setShortlisted] = useState([]);
//   const [interviewed, setInterviewed] = useState([]);
//   const [onboarded, setOnboarded] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // const token = localStorage.getItem("access_token");

//         const res = await axios.get(
//           `https://hrmsnew.prepstripe.com/api/dashboard/recruitment-summary?year=${selectedYear}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         const summary = res.data?.data?.summary || [];

//         setJobsOpened(summary.map((item) => item.jobs_opened));
//         setApplicationsReceived(summary.map((item) => item.applications_received));
//         setShortlisted(summary.map((item) => item.shortlisted))
//         setInterviewed(summary.map((item) => item.interviewed))
//         setOnboarded(summary.map((item) => item.onboarded))

//       } catch (error) {
//         console.error("Failed to fetch recruitment data:", error);
//       }
//     };

//     fetchData();
//   }, [selectedYear]);

//   const createGradients = (ctx, chartArea) => {
//     const presentGradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
//     presentGradient.addColorStop(0, "rgba(0, 119, 254, 0.3)");
//     presentGradient.addColorStop(1, "rgba(255, 255, 255, 0.1)");

//     const absentGradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
//     absentGradient.addColorStop(0, "rgba(13, 156, 108, 0.3)");
//     absentGradient.addColorStop(1, "rgba(255, 255, 255, 0.1)");

//     return { presentGradient, absentGradient };
//   };

//   const data = {
//     labels,
//     datasets: [
//       // one
//       {
//         label: "Applications Received",
//         data: applicationsReceived,
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) return "rgba(13, 156, 108, 0.2)";
//           const { absentGradient } = createGradients(ctx, chartArea);
//           return absentGradient;
//         },
//         borderColor: "#0D9C6C",
//         borderWidth: 1.5,
//         fill: "origin",
//         tension: 0.4,
//         pointRadius: 0,
//         pointHoverRadius: 4,
//         pointHoverBackgroundColor: "#0D9C6C",
//         pointHoverBorderColor: "#ffffff",
//         pointHoverBorderWidth: 2,
//       },
//       // two
//       {
//         label: "Jobs Opened",
//         data: jobsOpened,
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) return "rgba(0, 119, 254, 0.2)";
//           const { presentGradient } = createGradients(ctx, chartArea);
//           return presentGradient;
//         },
//         borderColor: "#0077FE",
//         borderWidth: 1.5,
//         fill: "-1",
//         tension: 0.4,
//         pointRadius: 0,
//         pointHoverRadius: 4,
//         pointHoverBackgroundColor: "#0077FE",
//         pointHoverBorderColor: "#ffffff",
//         pointHoverBorderWidth: 2,
//       },
//       // three
//       {
//         label: "Shortlisted",
//         data: shortlisted,
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) return "rgba(0, 119, 254, 0.2)";
//           const { presentGradient } = createGradients(ctx, chartArea);
//           return presentGradient;
//         },
//         borderColor: "#0C9D6D",
//         borderWidth: 1.5,
//         fill: "-1",
//         tension: 0.4,
//         pointRadius: 0,
//         pointHoverRadius: 4,
//         pointHoverBackgroundColor: "#0C9D6D",
//         pointHoverBorderColor: "#ffffff",
//         pointHoverBorderWidth: 2,
//       },
//       // four
//       {
//         label: "Interviewed",
//         data: interviewed,
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) return "rgba(0, 119, 254, 0.2)";
//           const { presentGradient } = createGradients(ctx, chartArea);
//           return presentGradient;
//         },
//         borderColor: "#0E9F6F",
//         borderWidth: 1.5,
//         fill: "-1",
//         tension: 0.4,
//         pointRadius: 0,
//         pointHoverRadius: 4,
//         pointHoverBackgroundColor: "#0E9F6F",
//         pointHoverBorderColor: "#ffffff",
//         pointHoverBorderWidth: 2,
//       },
//       // five
//       {
//         label: "Onboarded",
//         data: onboarded,
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) return "rgba(0, 119, 254, 0.2)";
//           const { presentGradient } = createGradients(ctx, chartArea);
//           return presentGradient;
//         },
//         borderColor: "#0A9D6B",
//         borderWidth: 1.5,
//         fill: "-1",
//         tension: 0.4,
//         pointRadius: 0,
//         pointHoverRadius: 4,
//         pointHoverBackgroundColor: "#0A9D6B",
//         pointHoverBorderColor: "#ffffff",
//         pointHoverBorderWidth: 2,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     interaction: {
//       mode: 'index',
//       intersect: false,
//     },
//     plugins: {
//       legend: { display: false },
//       tooltip: {
//         enabled: true,
//         backgroundColor: 'rgba(0, 0, 0, 0.8)',
//         titleColor: '#ffffff',
//         bodyColor: '#ffffff',
//         borderColor: '#E5E7EB',
//         borderWidth: 1,
//         cornerRadius: 6,
//         displayColors: true,
//         callbacks: {
//           title: (context) => {
//             return `${context[0].label} ${selectedYear}`;
//           },
//           label: (context) => {
//             return `${context.dataset.label}: ${context.parsed.y}`;
//           },
//         },
//       },
//     },
//     scales: {
//       x: {
//         grid: { display: false },
//         ticks: { color: "#6B7280" },
//       },
//       y: {
//         beginAtZero: true,
//         grid: { color: "#E5E7EB", borderDash: [4, 4] },
//         ticks: { stepSize: 25, color: "#6B7280" },
//       },
//     },
//   };

//   return (
//     <div className="h-[199px]">
//       <Line ref={chartRef} data={data} options={options} />
//     </div>
//   );
// };

// export default RecruitmentSummaryChart;

import React, { useRef, useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import axios from "axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { getToken } from "../../utils/tokenUtils";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const labels = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

const RecruitmentSummaryChart = ({ selectedYear }) => {
  const chartRef = useRef(null);
  const token = getToken()

  const [jobsOpened, setJobsOpened] = useState([]);
  const [applicationsReceived, setApplicationsReceived] = useState([]);
  const [shortlisted, setShortlisted] = useState([]);
  const [interviewed, setInterviewed] = useState([]);
  const [onboarded, setOnboarded] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const token = localStorage.getItem("access_token");

        const res = await axios.get(
          `https://hrmsnew.prepstripe.com/api/dashboard/recruitment-summary?year=${selectedYear}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const summary = res.data?.data?.summary || [];

        setJobsOpened(summary.map((item) => item.jobs_opened));
        setApplicationsReceived(summary.map((item) => item.applications_received));
        setShortlisted(summary.map((item) => item.shortlisted))
        setInterviewed(summary.map((item) => item.interviewed))
        setOnboarded(summary.map((item) => item.onboarded))

      } catch (error) {
        console.error("Failed to fetch recruitment data:", error);
      }
    };

    fetchData();
  }, [selectedYear]);

  const createGradients = (ctx, chartArea) => {
    const presentGradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
    presentGradient.addColorStop(0, "rgba(0, 119, 254, 0.3)");
    presentGradient.addColorStop(1, "rgba(255, 255, 255, 0.1)");

    const absentGradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
    absentGradient.addColorStop(0, "rgba(13, 156, 108, 0.3)");
    absentGradient.addColorStop(1, "rgba(255, 255, 255, 0.1)");

    return { presentGradient, absentGradient };
  };

  const data = {
    labels,
    datasets: [
      // one
      {
        label: "Applications Received",
        data: applicationsReceived,
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) return "rgba(13, 156, 108, 0.2)";
          const { absentGradient } = createGradients(ctx, chartArea);
          return absentGradient;
        },
        borderColor: "#10B981",
        borderWidth: 1.5,
        fill: "origin",
        tension: 0.4,
        pointRadius: 0,
        pointHoverRadius: 4,
        pointHoverBackgroundColor: "#10B981",
        pointHoverBorderColor: "#ffffff",
        pointHoverBorderWidth: 2,
      },
      // two
      {
        label: "Jobs Opened",
        data: jobsOpened,
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) return "rgba(0, 119, 254, 0.2)";
          const { presentGradient } = createGradients(ctx, chartArea);
          return presentGradient;
        },
        borderColor: "#3B82F6",
        borderWidth: 1.5,
        fill: "-1",
        tension: 0.4,
        pointRadius: 0,
        pointHoverRadius: 4,
        pointHoverBackgroundColor: "#3B82F6",
        pointHoverBorderColor: "#ffffff",
        pointHoverBorderWidth: 2,
      },
      // three
      {
        label: "Shortlisted",
        data: shortlisted,
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) return "rgba(0, 119, 254, 0.2)";
          const { presentGradient } = createGradients(ctx, chartArea);
          return presentGradient;
        },
        borderColor: "#F59E0B",
        borderWidth: 1.5,
        fill: "-1",
        tension: 0.4,
        pointRadius: 0,
        pointHoverRadius: 4,
        pointHoverBackgroundColor: "#F59E0B",
        pointHoverBorderColor: "#ffffff",
        pointHoverBorderWidth: 2,
      },
      // four
      {
        label: "Interviewed",
        data: interviewed,
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) return "rgba(0, 119, 254, 0.2)";
          const { presentGradient } = createGradients(ctx, chartArea);
          return presentGradient;
        },
        borderColor: "#EF4444",
        borderWidth: 1.5,
        fill: "-1",
        tension: 0.4,
        pointRadius: 0,
        pointHoverRadius: 4,
        pointHoverBackgroundColor: "#EF4444",
        pointHoverBorderColor: "#ffffff",
        pointHoverBorderWidth: 2,
      },
      // five
      {
        label: "Onboarded",
        data: onboarded,
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) return "rgba(0, 119, 254, 0.2)";
          const { presentGradient } = createGradients(ctx, chartArea);
          return presentGradient;
        },
        borderColor: "#8B5CF6",
        borderWidth: 1.5,
        fill: "-1",
        tension: 0.4,
        pointRadius: 0,
        pointHoverRadius: 4,
        pointHoverBackgroundColor: "#8B5CF6",
        pointHoverBorderColor: "#ffffff",
        pointHoverBorderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        borderColor: '#E5E7EB',
        borderWidth: 1,
        cornerRadius: 6,
        displayColors: true,
        callbacks: {
          title: (context) => {
            return `${context[0].label} ${selectedYear}`;
          },
          label: (context) => {
            return `${context.dataset.label}: ${context.parsed.y}`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#6B7280" },
      },
      y: {
        beginAtZero: true,
        grid: { color: "#E5E7EB", borderDash: [4, 4] },
        ticks: { stepSize: 25, color: "#6B7280" },
      },
    },
  };

  return (
    <div className="h-[199px]">
      <Line ref={chartRef} data={data} options={options} />
    </div>
  );
};

export default RecruitmentSummaryChart;